export default __webpack_public_path__ + "static/media/ga.86c28bc8.svg";